import { Injectable, OnDestroy, Optional, Injector, Inject } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle, ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

import { filter } from 'rxjs/operators';


import { MenuService } from 'fui-theme';

import { ReuseTabCached, ReuseTabMatchMode, ReuseTabNotify, ReuseTitle } from './interface';

/**
 * è·¯ç±å¤ç¨ç±»ï¼æä¾å¤ç¨æéè¦ä¸äºåºæ¬æ¥å£
 *
 * **æ³¨ï¼** ææç¼å­æ°æ®æ¥æºäºè·¯ç±ç¦»å¼åæä¼äº§ç
 */
@Injectable()
export class ReuseTabService implements OnDestroy {
    private _max = 10;
    private _debug = false;
    private _mode = ReuseTabMatchMode.Menu;
    private _excludes: RegExp[] = [ ];
    private _cachedChange: BehaviorSubject<ReuseTabNotify> = new BehaviorSubject<ReuseTabNotify>(null);
    private _cached: ReuseTabCached[] = [];
    private _titleCached: { [url: string]: ReuseTitle } = {};
    private _closableCached: { [url: string]: boolean } = {};
    private removeUrlBuffer: string;

    // region: public

    /** åè®¸æå¤å¤ç¨å¤å°ä¸ªé¡µé¢ï¼åå¼èå´ `2-100` */
    set max(value: number) {
        this._max = Math.min(Math.max(value, 2), 100);
        for (let i = this._cached.length; i > this._max; i--) {
            this._cached.pop();
        }
    }
    /** è®¾ç½®å¹éæ¨¡å¼ */
    set mode(value: ReuseTabMatchMode) {
        this._mode = value;
    }
    get mode() {
        return this._mode;
    }
    /** è®¾ç½®Debugæ¨¡å¼ */
    set debug(value: boolean) {
        this._debug = value;
    }
    get debug() {
        return this._debug;
    }
    /** æé¤è§åï¼é `mode=URL` */
    set excludes(values: RegExp[]) {
        if (!values) { return; }
        this._excludes = values;
    }
    get excludes() {
        return this._excludes;
    }
    /** è·åå·²ç¼å­çè·¯ç± */
    get items(): ReuseTabCached[] {
        return this._cached;
    }
    /** è·åå½åç¼å­çè·¯ç±æ»æ° */
    get count() {
        return this._cached.length;
    }
    /** è®¢éç¼å­åæ´éç¥ */
    get change(): Observable<ReuseTabNotify> {
        return this._cachedChange.asObservable(); // .pipe(filter(w => w !== null));
    }
    /** èªå®ä¹å½åæ é¢ */
    set title(value: string | ReuseTitle) {
        const curUrl = this.getUrl(this.injector.get(ActivatedRoute).snapshot);
        if (typeof value === 'string') {
            value = { text: value };
        }
        this._titleCached[curUrl] = value;
        this.di('update current tag title: ', value);
        this._cachedChange.next({ active: 'title', title: value, list: this._cached });
    }
    /** è·åæå®è·¯å¾ç¼å­æå¨ä½ç½®ï¼`-1` è¡¨ç¤ºæ ç¼å­ */
    index(url: string): number {
        return this._cached.findIndex(w => w.url === url);
    }
    /** è·åæå®è·¯å¾ç¼å­æ¯å¦å­å¨ */
    exists(url: string): boolean {
        return this.index(url) !== -1;
    }
    /** è·åæå®è·¯å¾ç¼å­ */
    get(url: string): ReuseTabCached {
        return url ? this._cached.find(w => w.url === url) || null : null;
    }
    private remove(url: string | number, includeNonCloseable: boolean): boolean {
        const idx = typeof url === 'string' ? this.index(url) : url;
        const item = idx !== -1 ? this._cached[idx] : null;
        if (!item || (!includeNonCloseable && !item.closable)) { return false; }

        this.destroy(item._handle);

        this._cached.splice(idx, 1);
        delete this._titleCached[url];
        return true;
    }
    /**
     * æ ¹æ®URLç§»é¤æ ç­¾
     *
     * @param [includeNonCloseable=false] æ¯å¦å¼ºå¶åå«ä¸å¯å³é­
     */
    close(url: string, includeNonCloseable = false) {
        this.removeUrlBuffer = url;

        this.remove(url, includeNonCloseable);

        this._cachedChange.next({ active: 'close', url, list: this._cached });

        this.di('close tag', url);
        return true;
    }
    /**
     * æ¸é¤å³è¾¹
     *
     * @param [includeNonCloseable=false] æ¯å¦å¼ºå¶åå«ä¸å¯å³é­
     */
    closeRight(url: string, includeNonCloseable = false) {
        const start = this.index(url);
        for (let i = this.count - 1; i > start; i--) {
            this.remove(i, includeNonCloseable);
        }

        this.removeUrlBuffer = null;

        this._cachedChange.next({ active: 'closeRight', url, list: this._cached });

        this.di('close right tages', url);
        return true;
    }
    /**
     * æ¸é¤ææç¼å­
     *
     * @param [includeNonCloseable=false] æ¯å¦å¼ºå¶åå«ä¸å¯å³é­
     */
    clear(includeNonCloseable = false) {
        this._cached.forEach(w => {
            if (!includeNonCloseable && w.closable) { this.destroy(w._handle); }
        });
        this._cached = this._cached.filter(w => !includeNonCloseable && !w.closable);

        this.removeUrlBuffer = null;

        this._cachedChange.next({ active: 'clear', list: this._cached });

        this.di('clear all catch');
    }
    /**
     * ç§»å¨ç¼å­æ°æ®
     * @param url è¦ç§»å¨çURLå°å
     * @param position æ°ä½ç½®ï¼ä¸æ ä» `0` å¼å§
     *
     * @example
     * ```
     * // source
     * [ '/a/1', '/a/2', '/a/3', '/a/4', '/a/5' ]
     * move('/a/1', 2);
     * // output
     * [ '/a/2', '/a/3', '/a/1', '/a/4', '/a/5' ]
     * move('/a/1', -1);
     * // output
     * [ '/a/2', '/a/3', '/a/4', '/a/5', '/a/1' ]
     * ```
     */
    move(url: string, position: number) {
        const start = this._cached.findIndex(w => w.url === url);
        if (start === -1) { return ; }
        const data = this._cached.slice();
        data.splice((position < 0 ? data.length + position : position), 0, data.splice(start, 1)[0]);
        this._cached = data;
        this._cachedChange.next({ active: 'move', url, position, list: this._cached });
    }
    /**
     * è·åæ é¢ï¼é¡ºåºå¦ä¸ï¼
     *
     * 1. ç»ä»¶åä½¿ç¨ `ReuseTabService.title = 'new title'` éæ°æå®ææ¬
     * 2. è·¯ç±éç½®ä¸­ data å±æ§ä¸­åå« titleI18n > title
     * 3. èåæ°æ®ä¸­ text å±æ§
     *
     * @param url æå®URL
     * @param route æå®è·¯ç±å¿«ç§
     */
    getTitle(url: string, route?: ActivatedRouteSnapshot): ReuseTitle {
        if (this._titleCached[url]) { return this._titleCached[url]; }

        if (route && route.data && (route.data.titleI18n || route.data.title)) {
            return <ReuseTitle>{ text: route.data.title, i18n: route.data.titleI18n };
        }

        const menu = this.mode !== ReuseTabMatchMode.URL ? this.getMenu(url) : null;
        return menu ? { text: menu.text, i18n: menu.i18n } : { text: url };
    }

    /**
     * æ¸é¤æ é¢ç¼å­
     */
    clearTitleCached() {
        this._titleCached = {};
    }
    /** èªå®ä¹å½å `closable` ç¶æ */
    set closable(value: boolean) {
        const curUrl = this.getUrl(this.injector.get(ActivatedRoute).snapshot);
        this._closableCached[curUrl] = value;
        this.di('update current tag closable: ', value);
        this._cachedChange.next({ active: 'closable', closable: value, list: this._cached });
    }
    /**
     * è·å `closable` ç¶æï¼é¡ºåºå¦ä¸ï¼
     *
     * 1. ç»ä»¶åä½¿ç¨ `ReuseTabService.closable = true` éæ°æå® `closable` ç¶æ
     * 2. è·¯ç±éç½®ä¸­ data å±æ§ä¸­åå« `reuseClosable`
     * 3. èåæ°æ®ä¸­ `reuseClosable` å±æ§
     *
     * @param url æå®URL
     * @param route æå®è·¯ç±å¿«ç§
     */
    getClosable(url: string, route?: ActivatedRouteSnapshot): boolean {
        if (typeof this._closableCached[url] !== 'undefined') { return this._closableCached[url]; }

        if (route && route.data && typeof route.data.reuseClosable === 'boolean') {
            return route.data.reuseClosable;
        }

        const menu = this.mode !== ReuseTabMatchMode.URL ? this.getMenu(url) : null;
        if (menu && typeof menu.reuseClosable === 'boolean') {
            return menu.reuseClosable;
        }

        return true;
    }
    /**
     * æ¸ç©º `closable` ç¼å­
     */
    clearClosableCached() {
        this._closableCached = {};
    }
    getTruthRoute(route: ActivatedRouteSnapshot) {
        let next = route;
        while (next.firstChild) { next = next.firstChild; }
        return next;
    }
    /**
     * æ ¹æ®å¿«ç§è·åURLå°å
     */
    getUrl(route: ActivatedRouteSnapshot): string {
        let next = this.getTruthRoute(route);
        const segments = [];
        while (next) {
            segments.push(next.url.join('/'));
            next = next.parent;
        }
        const url = '/' + segments.filter(i => i).reverse().join('/');
        return url;
    }
    /**
     * æ£æ¥å¿«ç§æ¯å¦åè®¸è¢«å¤ç¨
     */
    can(route: ActivatedRouteSnapshot): boolean {
        const url = this.getUrl(route);
        if (url === this.removeUrlBuffer) { return false; }

        if (route.data && typeof route.data.reuse === 'boolean') { return route.data.reuse; }

        if (this.mode !== ReuseTabMatchMode.URL) {
            const menu = this.getMenu(url);
            if (!menu) { return false; }
            if (this.mode === ReuseTabMatchMode.Menu) {
                if (menu.reuse === false) { return false; }
            } else {
                if (!menu.reuse || menu.reuse !== true) { return false; }
            }
            return true;
        }
        return this._excludes.findIndex(r => r.test(url)) === -1;
    }
    /**
     * å·æ°ï¼è§¦åä¸ä¸ª refresh ç±»åäºä»¶
     */
    refresh(data?: any) {
        this._cachedChange.next({ active: 'refresh', data });
    }
    // endregion

    // region: privates

    private destroy(_handle: any) {
        if (_handle && _handle.componentRef && _handle.componentRef.destroy) { _handle.componentRef.destroy(); }
    }

    private di(...args) {
        if (!this.debug) { return ; }
        // tslint:disable-next-line:no-console
        console.warn(...args);
    }

    // endregion

    constructor(
        private injector: Injector,
        @Optional() private menuService: MenuService
    ) {
    }

    private getMenu(url: string) {
        const menus = this.menuService ? this.menuService.getPathByUrl(url) : [];
        if (!menus || menus.length === 0) { return null; }
        return menus.pop();
    }

    private runHook(method: string, url: string, comp: any) {
        if (comp.instance && comp.instance.hasOwnProperty(method)) {
            comp.instance[method]();
        }
    }

    private hasInValidRoute(route: ActivatedRouteSnapshot) {
        return !route.routeConfig || route.routeConfig.loadChildren || route.routeConfig.children;
    }

    /**
     * å³å®æ¯å¦åè®¸è·¯ç±å¤ç¨ï¼è¥ `true` ä¼è§¦å `store`
     */
    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        if (this.hasInValidRoute(route)) { return false; }
        this.di('#shouldDetach', this.can(route), this.getUrl(route));
        return this.can(route);
    }

    /**
     * å­å¨
     */
    store(_snapshot: ActivatedRouteSnapshot, _handle: any) {
        if (this.count >= this._max) { this._cached.shift(); }
        const url = this.getUrl(_snapshot);
        const idx = this.index(url);

        const item: ReuseTabCached = {
            title: this.getTitle(url, _snapshot),
            closable: this.getClosable(url, _snapshot),
            url,
            _snapshot,
            _handle
        };
        if (idx === -1) {
            this._cached.push(item);
        } else {
            this._cached[idx] = item;
        }
        this.removeUrlBuffer = null;

        this.di('#store', idx === -1 ? '[new]' : '[override]', url);

        if (_handle && _handle.componentRef) {
            this.runHook('_onReuseDestroy', url, _handle.componentRef);
        }

        this._cachedChange.next({ active: 'add', item, list: this._cached });
    }

    /**
     * å³å®æ¯å¦åè®¸åºç¨ç¼å­æ°æ®
     */
    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        if (this.hasInValidRoute(route)) { return false; }
        const url = this.getUrl(route);
        const data = this.get(url);
        const ret = !!(data && data._handle);
        this.di('#shouldAttach', ret, url);
        return ret;
    }

    /**
     * æåå¤ç¨æ°æ®
     */
    retrieve(route: ActivatedRouteSnapshot): {} {
        if (this.hasInValidRoute(route)) { return null; }
        const url = this.getUrl(route);
        const data = this.get(url);
        const ret = (data && data._handle) || null;
        this.di('#retrieve', url, ret);
        if (ret && ret.componentRef) {
            this.runHook('_onReuseInit', url, ret.componentRef);
        }
        return ret;
    }

    /**
     * å³å®æ¯å¦åºè¯¥è¿è¡å¤ç¨è·¯ç±å¤ç
     */
    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        let ret = future.routeConfig === curr.routeConfig;
        if (!ret) { return false; }

        const path = ((future.routeConfig && future.routeConfig.path) || '') as string;
        // tslint:disable-next-line:no-bitwise
        if (path.length > 0 && ~path.indexOf(':')) {
            const futureUrl = this.getUrl(future);
            const currUrl = this.getUrl(curr);
            ret = futureUrl === currUrl;
        }
        this.di('=====================');
        this.di('#shouldReuseRoute', ret, `${this.getUrl(curr)}=>${this.getUrl(future)}`, future, curr);
        return ret;
    }

    ngOnDestroy(): void {
        this._cached = [];
        this._cachedChange.unsubscribe();
    }
}
